export default __webpack_public_path__ + "static/media/express.f533da95.png";